exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-loading[data-v-d15cdc22] {\n  height: calc(100vh - 276px);\n  width: 100%;\n  padding-right: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 32px;\n  padding-right: 80px;\n}\n", ""]);

// exports
